<template>
    <a-card>
        <div style="float: right;">
            <div class="table-toolbar">
                <a-button type="primary" @click="onEdit">编辑
                    <template #icon>
                        <form-outlined />
                    </template>
                </a-button>
            </div>
        </div>
        <div class="top">
<!--            <div class="imgBox">
                <img style="width: 100%;height: 100%;"
                     :src="detail.companyLogo ? getImg(detail.companyLogo) : '@/assets/img/defaultPhoto.png'" />
            </div>-->
            <div class="rightBox">
                <div class="topBox">
                    <p class="name">{{ detail.unitName }}</p>
                </div>
            </div>
        </div>
        <a-descriptions bordered :column="2" :labelStyle="{width: '150px'}">
            <a-descriptions-item label="单位性质">
                <dict-render :dict-obj="dictObjs['digital_unitNatureCode']" :text="detail.unitNatureCode"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="成立时间">{{ detail.establishedTime }}</a-descriptions-item>
            <a-descriptions-item :span="2" label="注册地">
                {{detail.registerAddress}}
            </a-descriptions-item>
            <a-descriptions-item :span="2" label="办公地址">{{detail.officeAddress}}</a-descriptions-item>
            <a-descriptions-item label="申报服务商方向">
                <dict-render :dict-obj="dictObjs['digital_serviceDirectionCode']" :text="detail.serviceDirectionCode"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="服务行业">
                <dict-render :dict-obj="dictObjs['digital_serviceTradeCode']" :text="detail.serviceTradeCode"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="联系人">{{ detail.contactPeople }}</a-descriptions-item>
            <a-descriptions-item label="联系电话">{{ detail.contactWay }}</a-descriptions-item>
            <a-descriptions-item label="数字化转型服务商申报书">
                <FileUpload v-model:value="detail.applyFile" :show-btn="false" disabled />
            </a-descriptions-item>
        </a-descriptions>
    </a-card>
    <SaveModal ref="save" :form-primary-key-field="listKeyField" @finish="getUnitInfo"/>
</template>

<script>
import DictRender from "@/components/other/DictRender";
import { dictMixin } from "@/mixins";
import { file_service } from "@/api/adminService";
import { companyDigitalInfo, companyInfo } from "@/api/companyService";
import SaveModal from "./components/UserModal";
import FileUpload from "../../../../components/form/upload/FileUpload";

export default {
    name: "index",
    mixins: [dictMixin],
    components: {
        FileUpload,
        SaveModal,
        DictRender
    },
    data() {
        return {
            dictNames: 'digital_serviceTradeCode,digital_serviceDirectionCode,digital_unitNatureCode',
            detail: {},
            listKeyField: "id",
        }
    },
    mounted() {
        this.getUnitInfo();
        // this.getCompanyInfo();
    },
    methods:{
        getCompanyInfo(){
            this.getAction({
                url: companyInfo.detail
            }).then(res => {
                this.detail.unitName = res.companyName
            })
        },
        getUnitInfo() {
            this.getAction({
                url: companyDigitalInfo.detail
            }).then(res => {
                this.detail = res||{}
                if (!this.detail.unitName){
                    this.getCompanyInfo();
                }
            })
        },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
        onEdit() {
            this.onShowModal('save', this.detail);
        },
        onShowModal(refName, data = {}) {
            const refEle = this.$refs[refName];
            refEle.form = Object.assign({}, data);
            refEle.visible = true;
        },
    }
}
</script>

<style scoped lang="less">
.top {
    overflow: hidden;
    margin-bottom: 10px;

    .imgBox {
        float: left;
        margin-right: 20px;
        width: 100px;
        height: 100px;
    }

    .rightBox {
        float: left;
        color: #333;
        width: 70%;

        .topBox {
            overflow: hidden;
            padding-bottom: 10px;

            .name {
                float: left;
                font-weight: 700;
                font-size: 24px;
            }

            .nameRight {
                float: left;
                margin-left: 25px;
                margin-top: 10px;
            }
        }

        .second {
            font-size: 16px;
            margin-top: 10px;
            display: flex;
            justify-content: space-around;

            .name {
                width: 50%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
            }
        }
    }
}
</style>
